import createAction from 'redux-actions/lib/createAction';

export const REGISTER_DATE_SELECTED = 'dayPickerActions/REGISTER_DATE_SELECTED';
export const registerDateSelected = createAction(REGISTER_DATE_SELECTED);
